import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './mandate.reducer';

export const Mandate = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const mandateList = useAppSelector(state => state.mandate.entities);
  const loading = useAppSelector(state => state.mandate.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="mandate-heading" data-cy="MandateHeading">
        <Translate contentKey="crawlerBackendApp.mandate.home.title">Mandates</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.mandate.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/mandate/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.mandate.home.createLabel">Create new Mandate</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {mandateList && mandateList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.mandate.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('bankAccountId')}>
                  <Translate contentKey="crawlerBackendApp.mandate.bankAccountId">Bank Account Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bankAccountId')} />
                </th>
                <th className="hand" onClick={sort('mandateReference')}>
                  <Translate contentKey="crawlerBackendApp.mandate.mandateReference">Mandate Reference</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mandateReference')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="crawlerBackendApp.mandate.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('signatureId')}>
                  <Translate contentKey="crawlerBackendApp.mandate.signatureId">Signature Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('signatureId')} />
                </th>
                <th className="hand" onClick={sort('signedAt')}>
                  <Translate contentKey="crawlerBackendApp.mandate.signedAt">Signed At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('signedAt')} />
                </th>
                <th className="hand" onClick={sort('entranceCode')}>
                  <Translate contentKey="crawlerBackendApp.mandate.entranceCode">Entrance Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entranceCode')} />
                </th>
                <th className="hand" onClick={sort('createdAt')}>
                  <Translate contentKey="crawlerBackendApp.mandate.createdAt">Created At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdAt')} />
                </th>
                <th className="hand" onClick={sort('updatedAt')}>
                  <Translate contentKey="crawlerBackendApp.mandate.updatedAt">Updated At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('updatedAt')} />
                </th>
                <th className="hand" onClick={sort('transactionUrl')}>
                  <Translate contentKey="crawlerBackendApp.mandate.transactionUrl">Transaction Url</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transactionUrl')} />
                </th>
                <th className="hand" onClick={sort('mandateTransactionCreateRequestKey')}>
                  <Translate contentKey="crawlerBackendApp.mandate.mandateTransactionCreateRequestKey">
                    Mandate Transaction Create Request Key
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mandateTransactionCreateRequestKey')} />
                </th>
                <th className="hand" onClick={sort('mandateTransactionResponseKey')}>
                  <Translate contentKey="crawlerBackendApp.mandate.mandateTransactionResponseKey">
                    Mandate Transaction Response Key
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mandateTransactionResponseKey')} />
                </th>
                <th className="hand" onClick={sort('mandateStatusResponseKey')}>
                  <Translate contentKey="crawlerBackendApp.mandate.mandateStatusResponseKey">
                    Mandate Status Response Key
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mandateStatusResponseKey')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {mandateList.map((mandate, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/mandate/${mandate.id}`} color="link" size="sm">
                      {mandate.id}
                    </Button>
                  </td>
                  <td>{mandate.bankAccountId}</td>
                  <td>{mandate.mandateReference}</td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.MandateStatus.${mandate.status}`} />
                  </td>
                  <td>{mandate.signatureId}</td>
                  <td>
                    {mandate.signedAt ? (
                      <TextFormat type="date" value={mandate.signedAt} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{mandate.entranceCode}</td>
                  <td>
                    {mandate.createdAt ? (
                      <TextFormat type="date" value={mandate.createdAt} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {mandate.updatedAt ? (
                      <TextFormat type="date" value={mandate.updatedAt} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{mandate.transactionUrl}</td>
                  <td>{mandate.mandateTransactionCreateRequestKey}</td>
                  <td>{mandate.mandateTransactionResponseKey}</td>
                  <td>{mandate.mandateStatusResponseKey}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/mandate/${mandate.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/mandate/${mandate.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/mandate/${mandate.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.mandate.home.notFound">No Mandates found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Mandate;
